export const PlusIcon = ({ color }: { color?: string }) => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.41675 6.41678V2.91678H7.58341V6.41678H11.0834V7.58345H7.58341V11.0834H6.41675V7.58345H2.91675V6.41678H6.41675Z"
                fill={color || 'currentColor'}
            />
        </svg>
    );
};
